// extracted by mini-css-extract-plugin
module.exports = {"container":"Graph_container__kyhDg","card":"Graph_card__28Eno"};